// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section[data-v-7257a234] {\n  padding-bottom: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
